import { Navigate } from 'react-router-dom';

// Legacy v1 password route. Redirects to Phase 2 magic-link path. Do not re-enable without explicit security review.
export default function Login() {
  return <Navigate to="/auth/signin" replace />;
}
